<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Finance & Economics </template>
    <template #description>
      Quantum technologies could transform finance and economics by improving the modeling of financial markets and enhancing risk management through the efficient processing of vast datasets. They will optimize operations in supply chains, increasing efficiency and reducing costs. Additionally, quantum innovations could drive economic growth by enabling the creation of new products and services, fostering entrepreneurship, and generating job opportunities. This, in turn, will lead to broader economic innovation and development.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Finance & Economics" />
    </template>
  </LImpact>
</template>

<style scoped></style>
